export const CATEGORY_TO_SEVERITY = {
  info: "info",
  warning: "warning",
  critical: "error",
  success: "success",
  error: "error",
} as const;

export type BannerCategory = keyof typeof CATEGORY_TO_SEVERITY;

export type BannerSeverity =
  typeof CATEGORY_TO_SEVERITY[keyof typeof CATEGORY_TO_SEVERITY];

export const VALID_VARIANTS = {
  standard: "standard",
  filled: "filled",
  outlined: "outlined",
} as const;

export type BannerVariant = typeof VALID_VARIANTS[keyof typeof VALID_VARIANTS];

export function mapCategoryToSeverity(category?: string): BannerSeverity {
  if (!category) return "info";
  return CATEGORY_TO_SEVERITY[category as BannerCategory] || "info";
}

export function mapVariant(variant?: string): BannerVariant {
  if (!variant) return "filled";
  return VALID_VARIANTS[variant as BannerVariant] || "filled";
}
